import { apiClient } from './apiClient';
import type { DashboardDto } from './dashboardApi';

export interface StaffSearchResult {
  employeeId: number;
  firstName: string;
  lastName: string;
  billingGrade: string;
  tenureInGrade: string;
}

export const occerSearchApi = {
  // excludePartners drops Partner grades — used by the manual Job End picker (WI #1103), which never
  // generates a Job End for Partners. Left false, the endpoint returns the full active-staff list.
  getActiveStaff: async (excludePartners = false): Promise<StaffSearchResult[]> => {
    const url = excludePartners ? '/occer-search/staff?excludePartners=true' : '/occer-search/staff';
    const response = await apiClient.get<StaffSearchResult[]>(url);
    return response.data;
  },

  getEmployeeDashboard: async (employeeId: number): Promise<DashboardDto> => {
    const response = await apiClient.get<DashboardDto>(`/dashboard/${employeeId}`);
    return response.data;
  },
};

export default occerSearchApi;
